import logo from "./logo.svg";
import "./App.scss";
import { DiscoBattle } from "./pages/discoBattle/DiscoBattle";

function App() {
  return (
    <div className="App">
      <DiscoBattle />
    </div>
  );
}

export default App;
